"use client";
import Link from "next/link";
import { useEffect, useState } from "react";
import { MdPhoneInTalk } from "react-icons/md";
import { getMenuItems } from "@/utils/data/page";
import { getContact } from "@/utils/data/contacts";
import { FaBars } from "react-icons/fa6";
import Img from "./Img";
import { usePathname } from "next/navigation";

export default function Header() {
  const pathname = usePathname();

  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
      setIsMenuOpen(false);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const phoneContact = getContact("phone");

  return (
    <header className="z-1000 fixed top-0 left-0 right-0 flex justify-center">
      <div
        className={`
          flex justify-center w-full bg-white shadow-md
          lg:transition-all lg:duration-500 lg:ease-in-out
          ${!isScrolled ? "lg:max-w-5xl lg:rounded-b-4xl" : "lg:max-w-full"}
        `}
      >
        <div className="flex flex-row items-center max-w-5xl w-full px-4">
          <Link
            className="
              mr-auto p-2 rounded-xl focus-outline -outline-offset-8
              lg:p-4
            "
            href="/"
          >
            <Img id="logo" priority />
          </Link>

          <div className="flex lg:hidden">
            {phoneContact && (
              <a
                className="button-outlined flex justify-center items-center w-11 h-11 ml-5"
                href={phoneContact.href}
                aria-label={phoneContact.label}
              >
                <MdPhoneInTalk size={24} />
              </a>
            )}

            <button
              className={`${
                isMenuOpen ? "button-outlined-active" : "button-outlined"
              } flex justify-center items-center w-11 h-11 ml-5`}
              aria-label={isMenuOpen ? "Főmenü bezárása" : "Főmenü megnyitása"}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <FaBars size={20} />
            </button>
          </div>

          <nav
            className={`
              absolute top-16 left-0 right-0 bg-white border-t-1 border-t-gray-300 transition-opacity shadow-md ${
                isMenuOpen ? "opacity-100 visible" : "opacity-0 invisible"
              }
              lg:static lg:opacity-100 lg:visible lg:border-t-0 lg:shadow-none`}
          >
            <ul className="flex flex-col lg:flex-row">
              {getMenuItems("header").map(({ title, route, url }) => (
                <li key={route} className="lg:mx-1">
                  <Link
                    className={`
                      focus-outline block p-4 -outline-offset-4
                      lg:my-4 lg:py-0 lg:leading-12 lg:rounded-full lg:hover:bg-primary lg:outline-offset-0 lg:hover:text-white
                      ${pathname === url ? "bg-secondary" : ""}
                    `}
                    aria-current={pathname === url}
                    href={url}
                  >
                    {title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {phoneContact && (
            <a
              className="hidden button-outlined w-11 h-11 ml-5 lg:inline-block"
              href={phoneContact.href}
              aria-label={phoneContact.label}
            >
              <MdPhoneInTalk size={24} />
            </a>
          )}
        </div>
      </div>
    </header>
  );
}
